import React, { Component } from 'react';
import Welcome from "../Welcome/Welcome";
import { apiURL } from '../Services/Base';
import Graph from '../Graph/Graph';
import Loading from '../Services/Loading/Loading';

const PollAuthorList = [
  {
      value: 1,
      name: "11",
      ordering: 1
  },
  {
      value: 2,
      name: "12",
      ordering: 1
  },
  {
      value: 3,
      name: "13",
      ordering: 1
  },
  {
      value: 4,
      name: "14",
      ordering: 1
  },
  {
      value: 5,
      name: "ידיעות אחרונות",
      ordering: 0
  }
];

const groupBy = (list, keyGetter) => {
  const map = new Map();
  list.forEach((item) => {
    const key = keyGetter(item);
    const collection = map.get(key);
    if (!collection) {
      map.set(key, [item]);
    } else {
      collection.push(item);
    }
  });
  return map;
}

export default class App extends Component {
  constructor() {
    super();
    this.state = {
      activeButton: 0,
      data: [],
      dates: [],
      Sokrim: [],
      list: [],
      currentSoker: null,
      currentDate: null
    }
  }
  componentDidMount() {
    this.getData(this.initDefaults);
  }
  setSokrimButtonValue = item => {
    const { data, currentDate } = this.state;
    let dates = data.filter(k => k.PollAuthor == item.PollAuthor).sort((a, b) => {
      return new Date(b.PollDate).getTime() - new Date(a.PollDate).getTime();
    }), _dates = [];
    if (this.state.activeButton == 0) {
      dates.map((obj, index) => {
        let date = obj.PollDate.split("T")[0].split("-");
        let listDate = `${parseInt(date[2]) < 10 ? date[2].replace("0", "") : date[2]}.${parseInt(date[1]) < 10 ? date[1].replace("0", "") : date[1]}`;
        if (_dates.toString().indexOf(listDate) == -1) {
          _dates.push(listDate);
        }
      })
    }
    if (this.state.activeButton == 1) {
      _dates = this.state.dates;
    }
    // console.log(currentDate, _dates[0]);
    this.setState({
      dates: _dates,
      currentDate: this.state.activeButton == 1 ? currentDate : _dates ? _dates[0] : null,
      currentSoker: item
    }, () => {
      if (this.state.activeButton == 0) {
        if (item.PollAuthor == -1) {
          this.getSummary();
          return;
        }
        this.getPollsByCompany();
        return;
      }
      this.getPollsByParty();
    });
  }
  setDateButtonValue = (item, Soker) => {
    this.setState({
      currentSoker: Soker,
      currentDate: item
    }, () => {
      if (this.state.activeButton == 0) {
        this.getPollsByCompany();
        return;
      }
      this.getPollsByParty();
    })
  }
  getData = (callback) => {
    fetch(`${apiURL}polls/Get_Banch`, {
      "Content-Type": "application/json"
    }).then(response => response.json()).then(data => {
      this.setState({
        data: data
      }, callback);
    }).catch(e => console.log(e));
  }
  getParties() {
    const { data } = this.state;
    let parties = [];
    data.forEach(obj => {
      obj.PollMiflaga.forEach(item => {
        if (item.Miflaga == "") return;
        if (parties.filter(k => k.PollAuthorLabel == item.Miflaga).length > 0) return;
        parties.push({ PollAuthorLabel: item.Miflaga })
      })
    })
    return parties;
  }
  initDefaults = () => {
    const { data } = this.state;
    let Sokrim = groupBy(data, k => k.PollAuthor), _Sokerim = [];
    _Sokerim.push({
      PollAuthor: -1,
      PollAuthorLabel: "ממוצע האחרונים",
      ordering: -1
    })
    Sokrim.forEach(obj => {
      _Sokerim.push({
        PollAuthor: obj[0].PollAuthor,
        PollAuthorLabel: PollAuthorList.filter(k => k.value == obj[0].PollAuthor)[0].name,
        ordering: PollAuthorList.filter(k => k.value == obj[0].PollAuthor)[0].ordering
      });
    })
    this.setState({
      data: data,
      dates: [],
      Sokrim: _Sokerim.sort((a, b) => a.ordering - b.ordering),
      currentSoker: null,
      currentDate: null,
      list: []
    }, this.getSummary);
  }
  initParties = () => {
    const { data } = this.state;
    let dates = [
      {
        numeric: "-1",
        label: "כל החודשים"
      }];
    if (data.filter(k => k.PollDate.indexOf("-01-") > -1).length > 0) {
      dates.push(
        {
          numeric: "01",
          label: "ינואר"
        })
    }
    if (data.filter(k => k.PollDate.indexOf("-02-") > -1).length > 0) {
      dates.push(
        {
          numeric: "02",
          label: "פברואר"
        })
    }
    if (data.filter(k => k.PollDate.indexOf("-03-") > -1).length > 0) {
      dates.push(
        {
          numeric: "03",
          label: "מרץ"
        })
    }
    if (data.filter(k => k.PollDate.indexOf("-04-") > -1).length > 0) {
      dates.push(
        {
          numeric: "04",
          label: "אפריל"
        })
    }

    let Parties = this.getParties();

    this.setState({
      dates: dates,
      Sokrim: Parties,
      currentSoker: Parties[0],
      currentDate: dates[0],
      list: []
    }, this.getPollsByParty);
  }
  setActiveButton = (index) => {
    this.setState({
      activeButton: index
    }, () => {
      switch (index) {
        case 0:
          this.initDefaults();
          break;
        case 1:
          this.initParties();
          break;
      }
    })
  }
  getPollsByCompany = () => {
    const { data, currentSoker, currentDate } = this.state;
    const datePattern = `${parseInt(currentDate.split(".")[1]) < 10 ? "0" + currentDate.split(".")[1] : currentDate.split(".")[1]}-${parseInt(currentDate.split(".")[0]) < 10 ? "0" + currentDate.split(".")[0] : currentDate.split(".")[0]}`;
    const byCompany = data.filter(k => k.PollAuthor == currentSoker.PollAuthor && k.PollDate.split("T")[0] == k.PollDate.split("T")[0].split("-")[0] + "-" + datePattern);
    this.setState({
      list: this.calCulateParties(byCompany)
    })
  }
  getPollsByParty = () => {
    const { data, currentSoker, currentDate } = this.state;
    let byParty = parseInt(currentDate.numeric) == -1 ? data.sort((a, b) => {
      return new Date(b.PollDate).getTime() - new Date(a.PollDate).getTime();
    }).filter(k => {
      return currentDate.numeric == -1 ? k.PollDate : k.PollDate.split("T")[0].indexOf(`-${currentDate.numeric}-`) > -1;
    }) : data.filter(k => {
      return k.PollDate.split("T")[0].indexOf(`-${currentDate.numeric}-`) > -1;
    });

    this.setState({
      list: this.calCulatDateParties(byParty).filter(k => k.Miflaga_proxy == currentSoker.PollAuthorLabel)
    })
  }
  getSummary = () => {
    this.setState({
      list: this.calCulateParties(this.state.data.sort((a, b) => {
        return new Date(b.PollDate).getTime() - new Date(a.PollDate).getTime();
      }).slice(0, 3), true)
    })
  }
  calCulatDateParties = (data) => {
    let parties = {}, partiesArray = [];
    data.forEach(obj => {
      let _parties = obj.PollMiflaga.filter(k => k.Miflaga != "");
      let month = obj.PollDate.split("T")[0].split("-")[1];
      let day = obj.PollDate.split("T")[0].split("-")[2];
      _parties.map((item, index) => {
        let itemName = `${obj.PollAuthor}_${month}_${day}_${item.Miflaga}`;
        parties = {
          ...parties,
          [itemName]: {
            ...parties[itemName],
            Miflaga: obj.PollAuthor,
            Miflaga_proxy: item.Miflaga,
            date: obj.PollDate.split("T")[0],
            ordering: obj.PollDate,
            Mandat: item.Mandat,
            Times: 1,
          }
        }
      });
    })

    for (let key in parties) {
      partiesArray.push(parties[key])
    }
    return partiesArray;
  }
  calCulateParties = (data, isSummary = false) => {
    let parties = {}, partiesArray = [];
    if (isSummary) {
      // data = data.slice(0, 2);
    }
    data.forEach(obj => {
      let _parties = obj.PollMiflaga.filter(k => k.Mandat != null);
      _parties.map((item, index) => {
        parties = {
          ...parties,
          [item.Miflaga]: {
            ...parties[item.Miflaga],
            Miflaga: item.Miflaga,
            Mandat: item.Mandat + (isSummary ? (parties[item.Miflaga] ? parties[item.Miflaga].Mandat : 0) : 0),
            Times: 1 + (isSummary ? (parties[item.Miflaga] ? parties[item.Miflaga].Times : 0) : 0),
          }
        }
      });
    })

    for (let key in parties) {
      partiesArray.push(parties[key])
    }
    return partiesArray;
  }
  render() {
    return (
      <div className="App">
        <Loading showLoading={this.state.Sokrim.length == 0} />
        {this.state.Sokrim.length > 0 ? <Welcome
          Sokrim={this.state.Sokrim}
          dates={this.state.dates}
          setSokrimButtonValue={this.setSokrimButtonValue}
          setDateButtonValue={this.setDateButtonValue}
          activeButton={this.state.activeButton}
          setActiveButton={this.setActiveButton} /> : ""}
        <Graph
          Sokrim={this.state.Sokrim}
          dates={this.state.dates}
          list={this.state.list}
          activeButton={this.state.activeButton} />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Components/App/App.jsx